<template>
    <div class="detail-info">
        <DetailInfoHeader
            :positionProvided="positionProvided"
            :showFixedBanner="showFixedBanner"
        ></DetailInfoHeader>
        <div class="mg-container">
            <div class="float-right" ref="right">
                <Schedule
                    v-if="info.listingStatus != 'Sold'"
                    :scheduleInfo="scheduleInfo"
                    :apptTitle="apptTitle"
                    :apptSubTitle="apptSubTitle"
                    :apptSubmitText="apptSubmitText"
                    :apptQuestionMsg="apptQuestionMsg"
                    ref="schedule"
                ></Schedule>
                <GetMoreInfo v-else></GetMoreInfo>
            </div>
            <div
                class="detail-info-group-container"
                ref="container"
                :class="{ 'open-read-more': openReadMore }"
            >
                <DetailInfoGroup
                    ref="group"
                    @refresh-parent="calcShowReadMore"
                ></DetailInfoGroup>
                <p
                    class="read-more"
                    :class="{ open: openReadMore }"
                    v-if="showReadMore"
                    @click="onReadMore"
                >
                    <span>{{
                        openReadMore
                            ? $t('md-detail-info.readLess')
                            : $t('md-detail-info.readMore')
                    }}</span>
                    <span class="iconfont icon-expand"></span>
                </p>
            </div>
        </div>
        <div class="mg-container">
            <MLS :provided="positionProvided === PROVIDED_POSITION_KEY.under && 'template4'"/>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore } from '@/store';
import util from '@/common/util';
import Schedule from '../schedule.vue';
import GetMoreInfo from './get-more-info.vue';
import DetailInfoHeader from './detail-info-header/index.vue';
import DetailInfoGroup from '../detail-info-group.vue';
import global from '../../../common/global';
import MLS from '../mls.vue';
import { PROVIDED_POSITION_KEY } from '@/common/mls';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    props: [
        'scheduleInfo',
        'positionProvided',
        'showFixedBanner',
        'apptTitle',
        'apptSubTitle',
        'apptSubmitText',
        'apptQuestionMsg'
    ],
    components: {
        DetailInfoHeader,
        DetailInfoGroup,
        Schedule,
        GetMoreInfo,
        MLS
    },
    data: function() {
        return {
            PROVIDED_POSITION_KEY,
            showReadMore: false
        };
    },
    inject: ['readMore'],
    mounted() {
        this.headerHeight = 100;
        let top = window
            .getComputedStyle(this.$refs.right)
            .getPropertyValue('margin-top');

        this.offsetTop = top ? -top.slice(0, -2) : 0;
        global.scroll(this.onScroll);
        this.calcShowReadMore();
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    methods: {
        calcShowReadMore() {
            if (util.isSSRServer) {
                return; 
            }
            this.$nextTick(() => {
                if (
                    this.$refs.group.$el.offsetHeight <
                        this.$refs.group.$el.scrollHeight &&
                    !this.openReadMore
                ) {
                    this.showReadMore = true;
                }
                if (
                    this.$refs.group.$el.offsetHeight > 500 &&
                    this.openReadMore
                ) {
                    this.showReadMore = true;
                }
            });
        },
        onReadMore() {
            let y = util.winScrollTop();
            this.readMore(() => {
                if (!this.openReadMore) {
                    this.$nextTick(() => {
                        this.$el.scrollIntoView();
                    });
                } else {
                    this.$nextTick(() => {
                        util.winScrollTop(y);
                    });
                }
                this.$nextTick(() => {
                    this.onScroll();
                });
            });
        },
        onScroll() {
            let right = this.$refs.right;

            if (
                this.$refs.container.offsetHeight <=
                right.offsetHeight - this.offsetTop
            ) {
                if (this.status == 'unactive') {
                    return;
                }
                right.style.position = 'static';
                this.status = 'unactive';
                return;
            }
            let containerRect = this.$refs.container.getBoundingClientRect();
            let rightRect = right.getBoundingClientRect();

            if (containerRect.top > this.headerHeight + this.offsetTop) {
                if (this.status == 'normal') {
                    return; 
                }
                right.style.position = 'static';
                this.status = 'normal';
                return;
            }
            if (containerRect.top <= this.headerHeight + this.offsetTop) {
                if (
                    containerRect.bottom >
                    this.headerHeight + right.offsetHeight
                ) {
                    if (this.status == 'fixed') {
                        return; 
                    }
                    right.style.position = 'fixed';
                    right.style.right = 'auto';
                    right.style.left = rightRect.left + 'px';
                    right.style.top = this.headerHeight + this.offsetTop + 'px';
                    right.style.bottom = 'auto';
                    this.status = 'fixed';
                } else {
                    if (this.status == 'bottom') {
                        return; 
                    }
                    right.style.position = 'absolute';
                    right.style.left = 'auto';
                    right.style.right = '0px';
                    right.style.bottom = '0px';
                    right.style.top = 'auto';
                    this.status = 'bottom';
                }
            }
        }
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        ...mapState({
            "listingDetail": "listingDetail",
            "agentInfo": "agentInfo",
            "triggerReadMore": "triggerReadMore",
            "openReadMore": "openReadMore"
        }),
        
        
        daysOnSite() {
            return this.listingDetail.daysOnSite || 10;
        },
        showShare() {
            return (
                this.listingDetail.facebookHref ||
                this.listingDetail.twitterHref ||
                this.listingDetail.linkedinHref
            );
        },
        info() {
            return this.listingDetail.info || {};
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-detail-info.fashion {
    .detail-info {
        position: relative;

        .float-right {
            float: right;
            width: 320px;
            margin-top: -100px;
            z-index: var(--level-low);
        }
        .detail-info-group-container {
            margin-right: 340px;
            .detail-info-group {
                max-height: 500px;
            }

            &.open-read-more {
                .detail-info-group {
                    max-height: none;
                }
            }
        }
        .read-more {
            width: 100%;
            background: #fff;
            @include color-theme();
            text-align: center;
            cursor: pointer;
            font-size: 14px;
            position: relative;
            &.open {
                .iconfont {
                    display: inline-block;
                    transform: rotate(180deg);
                }
                &::before {
                    display: none;
                }
            }
            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 0px;
                transform: translateY(-100%);
                height: 20px;
                background-image: linear-gradient(
                    to bottom,
                    rgba(255, 255, 255, 0),
                    #fff
                );
                width: 100%;
            }
        }
        .fix-wrap {
            display: none;
        }
    }
    @include media-1280 {
        .detail-info {
            .no-margin-top-pre-next {
                margin-top: 0;
            }
            .no-margin-top-pre-next {
                margin-top: 0;
            }
        }
    }

    @include media-800 {
        .detail-info {
            height: auto;
            .float-right {
                display: none;
            }
            .detail-info-group-container {
                margin-right: 0px;
            }
        }
        .read-more {
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }
}
</style>
